import React, { FunctionComponent } from 'react'
import E3DScriptLoader from '../e3d-script-loader/E3DScriptLoader'
import { useE3DInitialization } from '../hooks'

type Props = {
    is3DExhibitionEnabled: boolean
    isGrpLoading: boolean
    isGrpLoggedIn: boolean
}

const E3DAppInitializer: FunctionComponent<Props> = ({ is3DExhibitionEnabled, isGrpLoggedIn, isGrpLoading }) => {

    useE3DInitialization(is3DExhibitionEnabled)

    if (!is3DExhibitionEnabled) {
        return null
    }

    return (
        <>
            {(isGrpLoggedIn) && !isGrpLoading && <E3DScriptLoader />}
        </>
    )
}

export default E3DAppInitializer
